<template>
	<div class="section-content ">
		<div class="page-title">
			<div style="padding-top:2%;">
				道佑团队
				<img src="../assets/images/home_TitleLine.png" />
			</div>
		</div>
		<div
			style="background:linear-gradient(to bottom, #CECED0,#AAAAAA);display: flex;align-items: center;justify-content: space-between;padding-left: calc(12.1vh - 15px);padding-right: calc(12.1vh - 15px);">
			<div @click="clickLast" class="normalBtn">
				<i class='el-icon-arrow-left'></i>
			</div>

			<div class="userScorll" id="merchantScroll" style="display: flex;flex-direction: row; height:3%;cursor:pointer;
			width: calc(100vw - 12.1vh - 22.1vh);
			 overflow-x:hidden;">
				<div @click="chooseMerChant(item)" v-for="(item,index) in merList"
					style="width: 14vw;display: flex;align-items: center;">
					<div style="color: white;height:4.6vw;line-height:4.6vw;font-size: 1.6vw;font-weight: 600;width: 14vw;"
						:class="item.merchantName == currentMerchant ? 'chooseMer' :''">
						{{item.merchantName}}
					</div>
					<div v-if="index < merList.length - 1" style="background-color: #fff;width: 1px;height: 7vh;">
					</div>
				</div>

			</div>
			<div @click="clickNext" class="normalBtn" style="margin-left: 20px;">
				<i class='el-icon-arrow-right'></i>
			</div>
		</div>
		<div style="background:#F0F4FD;height:82%;">
			<div
				style="height:95%;display: flex;flex-direction: row;align-items: center;justify-content:space-around;margin-left: 12.1vh;margin-right: 12.1vh;background-color:#FBFCFF">
				<div @click="changeScroll(1)" style="font-size: 25px;height: 100px;display: flex;align-items: center;">
					<i class="el-icon-arrow-left" />
				</div>
				<div style=" width: calc(100vw - 12.1vh - 12.1vh - 80px);overflow-x: auto;height:94%;overflow-y:hidden;"
					id="zscroll" class="userScorll">

					<div style="white-space: nowrap;height:47%;margin-top:2%;" v-for="(item1,index1) in 2">
						<div v-for="(item,index) in userList" class="userItem1" v-if="index%2 == index1">
							<el-image fit="cover" style="height: 70%;width: 100%;border-radius: 8px 8px 0 0;"
								:src="item.avatar"></el-image>
							<div style="color: #000;font-size:1.3vw;font-weight:bold;margin-top:5px;">
								{{ item.nickName }}
							</div>
							<div v-if="item.job" style="color: #000;font-size: 0.9vw;margin-top:5px;">
								{{ item.job || "" }}
							</div>

							<div v-if="!item.job" style="color: #fff;font-size: 0.9vw;margin-top:5px;">
								无
							</div>

						</div>
					</div>

				</div>

				<div @click="changeScroll(2)" style="font-size: 25px;height: 100px;display: flex;align-items: center;">
					<i class="el-icon-arrow-right" />
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import {
		merchantlist,
		selectStaffList
	} from '@/api/webstation.js'
	export default {
		name: 'homeOne',
		components: {

		},
		data() {
			return {
				currentMerchant: "",
				userList: [],
				merList: [

				],
				intervalId: null

			}
		},
		mounted() {


			let that = this
			that.getmerchantlist()

			this.$nextTick(() => {
				that.autoSroll("zscroll");
			})



		},
		beforeDestroy() {
			clearInterval(this.intervalId);
		},

		methods: {

			getSelectStaffList(merId) {
				let that = this
				selectStaffList({
					"pageNum": "1", // 当 前   页
					"pageSize": "10000000", //每页展示的条数
					"merchantId": merId,
					"type": 1
				}).then(res => {
					if (res.code == 200) {
						that.userList = res.rows

					}
				})
			},
			getmerchantlist() {
				let that = this
				merchantlist({
					"pageNum": "1", //当前页
					"pageSize": "1000", //每页展示的条数
					"merchantName": '',
					"type": 1,
					status:1
				}).then(res => {
					if (res.code == 200) {
						that.merList = res.rows

						that.currentMerchant = that.merList[0].merchantName
						that.getSelectStaffList(that.merList[0].merchantId)
					}
				})
			},

			clickNext() {

				const merchantScroll = document.getElementById('merchantScroll')
				var current = merchantScroll.scrollLeft;
				let width = window.innerWidth * 0.14
				merchantScroll.scrollLeft = current + width;

			},
			clickLast() {

				const merchantScroll = document.getElementById('merchantScroll')
				var current = merchantScroll.scrollLeft;
				let width = window.innerWidth * 0.14
				merchantScroll.scrollLeft = current - width;

			},
			changeScroll(type) {
				const scrollELE = document.getElementById('zscroll')
				var current = scrollELE.scrollLeft;
				if (type == 1) {
					scrollELE.scrollLeft = current - 120;
				} else {
					scrollELE.scrollLeft = current + 120;
				}

			},

			chooseMerChant(item) {
				this.currentMerchant = item.merchantName


				this.getSelectStaffList(item.merchantId)
				this.$forceUpdate()
			},

			autoSroll(Id) {


				// flag 为true时停止滚动  
				var flag = false;
				// 定时器  

				let that = this

				function roll() {
					var h = -1;


					that.intervalId = setInterval(function() {
						// console.log('document.getElementById(Id): ',document.getElementById(Id));
						if (document.getElementById(Id))

						{
							flag = true;
							//获取当 前滚动条高度
							var current = document.getElementById(Id).scrollLeft;
							// console.log('current: ',current);
							if (current == h) {
								//滚动到底端,返回顶端
								h = 0;
								document.getElementById(Id).scrollLeft = h + 1;
							} else {

								h = current;
								document.getElementById(Id).scrollLeft = h + 1;
							}
						}

					}, 30);

				}
				// setTimeout(function() {
				//鼠标悬浮暂停。
				document.getElementById(Id).onmouseenter = () => {
					if (flag) {
						flag = false;
						clearInterval(that.intervalId);
					}
				};
				//鼠标移开继续 
				document.getElementById(Id).onmouseleave = () => {
					if (!flag) {
						flag = true;
						roll();
					}
				};
				roll();
			},


		}
	}
</script>

<style scoped>
	@import '../assets/home.css';

	.userItem1 {
		height: 90%;
		width: 19.2vh;
		margin-right: 1.6vw;
		margin-left: 1.6vw;
		display: inline-block;
		background: #fff;
		border-radius: 8px;
	}

	.userItem1:first-child {

		margin-left: 0;
	}

	.userItem1:last-child {

		margin-right: 0;
	}

	.normalBtn {
		background-color: #999999;
		width: 30px;
		height: 30px;
		border-radius: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: large;
	}

	.normalBtn:hover {
		background-color: #083A81;
	}

	.chooseMer {
		font-size: 1.8vw !important;
		color: #1c6ce6 !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/home_five.vue